const parser = new DOMParser()

const formatParagraphs = (nodes: ChildNode[]) => {
  return nodes.map((node) => {
    const textContent = node.textContent?.trim()

    if (node.nodeName === 'P') {
      return textContent + '\n'
    } else {
      return textContent
    }
  })
}

const formatLinks = (document: Document): ChildNode[] => {
  const nodes = Array.from(document.body.childNodes)

  return nodes.map((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      const links = (node as Element).querySelectorAll('a')
      if (!links.length) return node

      links.forEach((link) => {
        const formattedLink = document.createTextNode(`${link.textContent?.trim()} (${link.href})`)
        node.replaceChild(formattedLink, link)
      })

      return node
    } else {
      return node
    }
  })
}

export const HTMLToPlainText = (html: string): string => {
  const doc = parser.parseFromString(html, 'text/html')
  const nodes = formatLinks(doc)
  const parsedNodes = formatParagraphs(nodes)

  return parsedNodes.join('')
}
